import React from "react";

const Hashtag = () => {
  return <span className="text-[#c470db]">#</span>;
};

export default Hashtag;
